import { Link } from 'react-router-dom'
import { Logo } from '../ui/logo'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t bg-white/80 backdrop-blur-sm dark:bg-gray-900/80 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Company Info */}
          <div className="space-y-4">
            <Logo />
            <p className="text-sm text-muted-foreground max-w-xs">
              Intelligent AI Tools to Transform Your Educational Experience.
            </p>
            <div className="text-sm text-muted-foreground">
              © {currentYear} Veridian Labs.<br />
              All rights reserved.
            </div>
          </div>

          {/* Product */}
          <div className="space-y-4">
            <h3 className="font-semibold text-sm uppercase tracking-wider">Product</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/dashboard/home"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/assistants"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  AI Assistants
                </Link>
              </li>
              <li>
                <Link
                  to="/dashboard/reports"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Analytics
                </Link>
              </li>
              <li>
                <Link
                  to="/nursing"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Nursing
                </Link>
              </li>
              <li>
                <Link
                  to="/help"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Help Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h3 className="font-semibold text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://botnexus.ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="https://veridianlabs.co/#contact"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Contact
                </a>
              </li>
              <li>
                <button
                  onClick={() => window.open('https://calendly.com/veridianlabs/30min', '_blank')}
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors text-left"
                >
                  Book a Demo
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h3 className="font-semibold text-sm uppercase tracking-wider">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-muted-foreground hover:text-orange-600 transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-2 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-xs text-muted-foreground">
              Botnexus is committed to protecting student privacy and complies with FERPA and COPPA regulations.
            </div>
            <div className="flex items-center space-x-4">
              {/* <a 
                href="https://botnexus.ai/#contact" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs text-muted-foreground hover:text-orange-600 transition-colors"
              >
                Support
              </a> */}
              <span className="text-xs text-muted-foreground">•</span>
              {/* <a 
                href="https://botnexus.ai/#contact"
                className="text-xs text-muted-foreground hover:text-orange-600 transition-colors"
              >
                Privacy Questions
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
